import  { APIClient } from "../api";

export default class ContractService extends APIClient {

    async getContractById(idContract: number) {
        const url = `${this.endpoint}/Contract/${idContract}`;

        return this.api({
            method: 'get',
            url
        });
    }

    async getCurrentContractsByIdCustomer(idCustomer: number) {
        const url = `${this.endpoint}/Contract/GetCurrentContractsByIdCustomer/${idCustomer}`;

        return this.api({
            method: 'get',
            url
        });
    }
}